import React, { useEffect, useState } from 'react';
import useManageOrder from './useManageOrder';
import { formatDate } from '../../utils/dateUtils';
import TextField from '@mui/material/TextField';
import { toast } from 'react-toastify';
import NoDeliveryFeeRow from './NoDeliveryFeeRow';
import ShipDateDropdown from '../../sharedComponents/ShipDateDropdown';
import { useAuth } from '../../context/AuthContext';

const NoDeliveryFee = () => {
  const { authState } = useAuth();

  const [searchText, setSearchText] = useState('')
  const {orders, getNoDeliveryFeeOrder, updateOrder} = useManageOrder()
  const [order, setOrder] = useState({})
  const [shipDateId, setShipDateId] = useState('')

  const handleUpdate = async (updatedOrder) => {
    const response = await updateOrder(updatedOrder, authState.user.id)
    if(response){
      toast.success("Update successful")
    }else{
      toast.error("Update Fail")
    }
  }

  const handleSelectChange = (e) => {
    setShipDateId(e.target.value)
  }

  useEffect(() => {
    // Define an async function inside the useEffect
    const fetchData = async () => {
      console.log(orders)
      const response = await getNoDeliveryFeeOrder(shipDateId);
    };
  
    // Call the async function
    fetchData();
  }, [shipDateId]); // Dependency array, re-run the useEffect when shipDateId changes
  


  return (
    <div>
      <h2>รายการสินค้า ไม่มีค่าส่งในญี่ปุ่น</h2>
      <ShipDateDropdown 
        handleDataChange={handleSelectChange}
        includeDefault={true}
      />
      <table className='min-w-full border-collapse border border-gray-300 mt-2'>
        <thead>
        <tr className="bg-gray-100">
          <td className='p-4 border-b border-gray-200 text-left text-sm font-semibold'>Contact</td>
          <td className='p-4 border-b border-gray-200 text-left text-sm font-semibold'>Smile Name</td>
          <td className='p-4 border-b border-gray-200 text-left text-sm font-semibold'>Order Date</td>
          <td className='p-4 border-b border-gray-200 text-left text-sm font-semibold'>Link</td>
          <td className='p-4 border-b border-gray-200 text-left text-sm font-semibold'>Tracking</td>
          <td className='p-4 border-b border-gray-200 text-left text-sm font-semibold'>Japan Delivery Fee</td>
          <td className='p-4 border-b border-gray-200 text-left text-sm font-semibold'><button>Update</button></td>
        </tr>
        </thead>
        <tbody>
        {orders.length && orders.map((order,index) => (
          <NoDeliveryFeeRow order={order} handleSave={handleUpdate}/>
        ))}
        </tbody>
      </table>
    </div>
  );
}

export default NoDeliveryFee;
